module.exports = "../fonts/children_food_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/children_food_icon.svg
// module id = 439
// module chunks = 0